export default __webpack_public_path__ + "static/media/dds5168b.5b9da7a4.png";